import { IconContent } from '@icons';

export const orderDown: IconContent = {
    md: '<path d="M6 5v11.793l-1.646-1.647-.708.708 2.5 2.5.354.353.354-.353 2.5-2.5-.708-.708L7 16.793V5H6Zm13 0h-8v1h8V5Zm-8 3h8v1h-8V8Zm8 3h-8v1h8v-1Zm-8 3h5v1h-5v-1Zm5 3h-5v1h5v-1Z" />',
};
